import fb from '@/firebaseConfig';
import { getNewArrayNoRepeats } from '@/helpers/contentHelpers';
import { isToday } from '@/helpers/timeHelpers';

/*
 * Daily Cards
 * - Generate 7 IDs for each time of day
 * - Track index & update each day user opens app
 * - After 7 days, generate new IDs, not including IDs from previous week
 *
 * Edge Cases
 * - Change in subscription status => Reset IDs on subscription change
 * - Card is deleted/not accessible => Check if user can access
 * - Cards not loaded yet => Use fallback IDs that load with skeleton loader
 */

// TODO Reset daily card IDS when subscription status changes

/*

  STATE

 */

const state = {
  dailyIndex: 0,
  morningIds: [],
  dayIds: [],
  nightIds: [],
  indexUpdatedAt: null, // When index was last updated
  dailyCardsLoaded: false,
};

/*

  GETTERS

 */

const getters = {
  dailyIds: state => {
    const { dailyIndex: i, morningIds, dayIds, nightIds } = state;
    return [morningIds[i] || '', dayIds[i] || '', nightIds[i] || ''];
  },
};

/*

  ACTIONS

 */

const actions = {
  // Called from user/init and cards/init
  init({ dispatch, state, rootState }) {
    const { dailyIndex, dayIds, indexUpdatedAt, dailyCardsLoaded } = state;
    const cardsLoaded = rootState.cards.isLoaded;

    if (cardsLoaded && dailyCardsLoaded && !isToday(indexUpdatedAt)) {
      if (dailyIndex === 6 || !dayIds.length) {
        dispatch('generateDailyCards');
      } else {
        dispatch('updateIndex');
      }
    } else {
      dispatch('user/saveUserInitDataToDB', { moduleName: 'dailyCards' }, { root: true });
    }
  },

  generateDailyCards({ commit, dispatch, state, rootState }) {
    const { morningIds, dayIds, nightIds } = state;
    const { lighteningIds, journeyIds, deepeningIds } = rootState.cards;

    const data = {
      morningIds: getNewArrayNoRepeats(morningIds, lighteningIds, 7),
      dayIds: getNewArrayNoRepeats(dayIds, journeyIds, 7),
      nightIds: getNewArrayNoRepeats(nightIds, deepeningIds, 7),
      dailyIndex: 0,
      indexUpdatedAt: fb.currentTimestamp(),
    };
    commit('setDailyCards', data);

    dispatch(
      'user/saveUserInitDataToDB',
      {
        moduleName: 'dailyCards',
        moduleData: { dailyCards: data },
      },
      { root: true }
    );
  },

  updateIndex({ commit, dispatch, state }) {
    const dailyIndex = state.dailyIndex + 1;
    const indexUpdatedAt = fb.currentTimestamp();
    commit('setIndex', { dailyIndex, indexUpdatedAt });

    dispatch(
      'user/saveUserInitDataToDB',
      {
        moduleName: 'dailyCards',
        moduleData: {
          'dailyCards.dailyIndex': dailyIndex,
          'dailyCards.indexUpdatedAt': fb.currentTimestamp(),
        },
      },
      { root: true }
    );
  },
};

/*

  MUTATIONS

 */

const mutations = {
  // Called from user init and generateDailyCards
  setDailyCards(state, data) {
    if (data) {
      state.morningIds = data.morningIds || [];
      state.dayIds = data.dayIds || [];
      state.nightIds = data.nightIds || [];
      state.dailyIndex = data.dailyIndex || 0;
      state.indexUpdatedAt = data.indexUpdatedAt ? data.indexUpdatedAt.toDate() : null;
    }
    state.dailyCardsLoaded = true;
  },

  setIndex(state, { dailyIndex, indexUpdatedAt }) {
    state.dailyIndex = dailyIndex;
    state.indexUpdatedAt = indexUpdatedAt;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

// No longer showing user whether they viewed daily cards or not
//   updateViewedTime({ commit, dispatch, getters, rootState }, cardId) {
//     const userId = rootState.user.uid;
//     const { dailyIds } = getters;
//     const index = dailyIds.indexOf(cardId);
//     const times = ['morning', 'day', 'night'];
//     const timeOfDay = times[index];

//     if (timeOfDay) {
//       const viewedToday = getters[`${timeOfDay}ViewedToday`];
//       if (!viewedToday) {
//         const viewedAt = moment().format();

//         commit('setViewedAt', { timeOfDay, viewedAt });

//         fb.usersCollection
//           .doc(userId)
//           .update({ [`dailyCards.${timeOfDay}ViewedAt`]: viewedAt })
//           .catch(error => {
//             console.log('Error updating daily cards', error);
//           });
//       }
//     }
//   },
